import React from 'react';
import Step1 from './Step1';

class AddUser extends React.Component{
    render(){
        return(
            <div className="add-user-section">
                <Step1/>
            </div>
        )
    }
}

export default AddUser;


// WEBPACK FOOTER //
// ./src/components/addUser/AddUser.js